import Highcharts from "highcharts/esm/highcharts.src"

import { useMemo } from "react"

import { colors } from "@minuthq/meatball-ui-react"
import HighchartsReact from "highcharts-react-official"

type DonutChartProps = {
  data: Highcharts.SeriesPieOptions["data"]
  title: {
    text: string
  }
  seriesColors: string[]
  containerProps?: Highcharts.Options["chart"]
  labelFormatter?: (this: Highcharts.Point) => string
}

export function DonutChart({
  data,
  title,
  seriesColors,
  containerProps,
  labelFormatter,
}: DonutChartProps) {
  const series: Highcharts.Options["series"] = useMemo(
    () => [
      {
        type: "pie",
        data,
        colors: seriesColors,
        innerSize: "60%",
        enableMouseTracking: false,
      },
    ],
    [data, seriesColors]
  )

  const options = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: "pie",
    },
    title: {
      align: "center",
      verticalAlign: "middle",
      text: title.text,
      floating: true,
      useHTML: true,
      y: -10,
      style: {
        fontSize: "24px",
        color: colors.textPrimary,
        fontFamily: "'Figtree', sans-serif",
      },
    },
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    accessibility: { enabled: false },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: "pointer",
        dataLabels: {
          enabled: false,
        },
        showInLegend: true,
      },
    },
    legend: {
      layout: "vertical",
      itemStyle: {
        color: colors.textPrimary,
        fontFamily: "'Figtree', sans-serif",
        fontSize: "16px",
      },
      labelFormatter,
      symbolRadius: "100%",
    },

    series,
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={options}
      containerProps={containerProps}
    />
  )
}
